import { render, staticRenderFns } from "./repayment-deleted.vue?vue&type=template&id=3dd61efe&"
import script from "./repayment-deleted.vue?vue&type=script&lang=js&"
export * from "./repayment-deleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports